import React, { createContext, useContext, useState } from "react";
import * as battleService from "../services/battle";

const BattleContext = createContext(null);

export const BattleProvider = ({ children }) => {
  const [battles, setBattles] = useState([]);
  const [currentBattle, setCurrentBattle] = useState(null);
  const [stats, setStats] = useState(null);

  const createBattle = async (battleData) => {
    try {
      const newBattle = await battleService.createBattle(battleData);
      setBattles([newBattle, ...battles]);
      return newBattle;
    } catch (error) {
      throw error;
    }
  };

  const getBattle = async (battleId) => {
    try {
      const battle = await battleService.getBattle(battleId);
      setCurrentBattle(battle);
      return battle;
    } catch (error) {
      throw error;
    }
  };

  const getBattleHistory = async () => {
    try {
      const history = await battleService.getBattleHistory();
      setBattles(history);
      return history;
    } catch (error) {
      throw error;
    }
  };

  const getBattleStats = async () => {
    try {
      const battleStats = await battleService.getBattleStats();
      setStats(battleStats);
      return battleStats;
    } catch (error) {
      throw error;
    }
  };

  const value = {
    battles,
    currentBattle,
    stats,
    createBattle,
    getBattle,
    getBattleHistory,
    getBattleStats,
  };

  return <BattleContext.Provider value={value}>{children}</BattleContext.Provider>;
};

export const useBattle = () => {
  const context = useContext(BattleContext);
  if (!context) {
    throw new Error("useBattle must be used within a BattleProvider");
  }
  return context;
};
